var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcEditPrice(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#484848",
    d: "M3.59 12.25c.297 0 .528-.205.528-.507v-.756c1.707-.162 3.028-1.133 3.028-2.763 0-1.468-.97-2.353-2.885-2.687l-.143-.033v-3.01c.782.14 1.332.604 1.552 1.327.11.323.32.529.672.529.374 0 .65-.26.65-.637 0-.108-.033-.216-.055-.335-.287-1.165-1.41-1.964-2.82-2.126V.507C4.118.205 3.888 0 3.59 0c-.297 0-.517.205-.517.507v.745C1.398 1.435.22 2.461.22 3.929c0 1.37.936 2.19 2.775 2.612l.077.021v3.195c-.991-.14-1.575-.68-1.75-1.403-.122-.367-.353-.54-.683-.54-.375 0-.639.26-.639.637 0 .119.022.227.055.334.308 1.242 1.542 2.04 3.017 2.18v.778c0 .302.22.507.517.507z",
    transform: "translate(-512 -666) translate(0 592) translate(502) translate(10 74) translate(3.5 .875)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M3.063 5.104L3.01 5.08c-.676-.313-.968-.796-.968-1.507 0-.736.382-1.35 1.02-1.531v3.062zM4.083 6.125l.282.056c1.303.304 1.76.766 1.76 1.487 0 .788-.672 1.384-2.042 1.52V6.124z",
    transform: "translate(-512 -666) translate(0 592) translate(502) translate(10 74) translate(3.5 .875)"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEditPrice);
export default __webpack_public_path__ + "static/media/ic-edit-price.019fc1f79b3c1e6b0444befa5ee98ba9.svg";
export { ForwardRef as ReactComponent };